import React from "react";
import { useTable } from "react-table";

import { Box, Flex, Icon, Table, Thead, Tbody, Tr, Th, Td, Text } from "@chakra-ui/react";
import { FaSort, FaSortUp, FaSortDown } from "react-icons/fa";

import TablePagination from "../TablePagination";
import LoadingSpinner from "../LoadingSpinner";
import SemRegistros from "../SemRegistros";

export default function TableAuditoria({
  columns,
  data,
  loading,
  entidade,
  pageIndex,
  pageSize,
  pageCount,
  totalItems,
  onPageChange,
  onPageSizeChange,
  sortField,
  sortType,
  onSort,
}) {
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({ columns, data: data || [] });

  const irParaPagina = (index) => {
    const safeIndex = Math.max(0, Math.min(index, pageCount - 1));
    onPageChange(safeIndex);
  };

  const selecionarTotalItens = (novoPageSize) => {
    onPageSizeChange(novoPageSize);
  };

  return (
    <Box w="100%" mt="20px">
      {loading ? (
        <Box mt={4} textAlign="center">
          <LoadingSpinner />
        </Box>
      ) : data && data.length > 0 ? (
        <>
          <Flex overflowX="auto" pb={5}>
            <Table {...getTableProps()} backgroundColor="white">
              <Thead backgroundColor="#ECEFF1">
                {headerGroups.map((headerGroup, i) => (
                  <Tr {...headerGroup.getHeaderGroupProps()} key={i}>
                    {headerGroup.headers.map((column, j) => {
                      const sortKey = column.sortKey || column.id;
                      const isSortable = !column.disableSort && !!onSort;
                      const isActive = isSortable && sortField === sortKey;

                      return (
                        <Th {...column.getHeaderProps()} key={j} p="0px">
                          <Flex
                            flexDir="row"
                            alignContent="center"
                            px="24px"
                            py="12px"
                            cursor={isSortable ? "pointer" : "default"}
                            onClick={isSortable ? () => onSort(sortKey) : undefined}
                          >
                            <Text as="p">{column.render("Header")}</Text>
                            {isSortable && (
                              <Flex pl={1} alignItems="center">
                                {isActive ? (
                                  sortType === "DESC" ? (
                                    <Icon as={FaSortDown} boxSize="14px" />
                                  ) : (
                                    <Icon as={FaSortUp} boxSize="14px" />
                                  )
                                ) : (
                                  <Icon as={FaSort} boxSize="14px" />
                                )}
                              </Flex>
                            )}
                          </Flex>
                        </Th>
                      );
                    })}
                  </Tr>
                ))}
              </Thead>
              <Tbody {...getTableBodyProps()}>
                {rows.map((row, i) => {
                  prepareRow(row);
                  return (
                    <Tr {...row.getRowProps()} key={i}>
                      {row.cells.map((cell, j) => (
                        <Td
                          py="6px"
                          fontWeight={400}
                          fontSize="13px"
                          lineHeight="21.6px"
                          {...cell.getCellProps()}
                          key={j}
                        >
                          {cell.render("Cell")}
                        </Td>
                      ))}
                    </Tr>
                  );
                })}
              </Tbody>
            </Table>
          </Flex>
          <TablePagination
            entidade={entidade}
            loading={loading}
            rows={rows}
            totalItems={totalItems}
            pageSize={pageSize}
            pageIndex={pageIndex}
            currentPage={pageIndex}
            pageCount={pageCount}
            pageOptions={Array.from({ length: pageCount || 0 })}
            canPreviousPage={pageIndex > 0}
            canNextPage={pageIndex < (pageCount || 1) - 1}
            gotoPage={irParaPagina}
            irParaPagina={irParaPagina}
            selecionarTotalItens={selecionarTotalItens}
          />
        </>
      ) : (
        <SemRegistros loading={loading} entidade={entidade} buttonVisible half />
      )}
    </Box>
  );
}
